import { View } from 'react-native';

import { Text } from '@/components/ui/Text';
import { type TemplateItem } from '@/lib/data';
import { itemLabelKey, itemNotesKey } from '@/lib/presence/fieldKeys';

import { SpectatorField } from './SpectatorField';

/** A template step as read-only members see it, including live focus claims. */
export function SpectatorStep({ item }: { item: TemplateItem }) {
  return (
    <View className="py-3">
      <SpectatorField fieldKey={itemLabelKey(item.id)} className="self-start">
        <Text variant="bodyMedium">{item.label}</Text>
      </SpectatorField>
      <SpectatorField
        fieldKey={itemNotesKey(item.id)}
        onlyWhenClaimed={!item.notes}
        className="ml-9 mt-1 self-start"
      >
        {item.notes ? (
          <Text variant="caption" className="text-foreground-secondary">
            {item.notes}
          </Text>
        ) : null}
      </SpectatorField>
    </View>
  );
}
